import React, { useEffect, useState } from "react";
import { onConnect } from "../core/web3";

function WalletConnect({ wallet, setWallet }) {
  const onConnect1 = async () => {
    let res = await onConnect();
    setWallet(res.address != "");
  };
  return (
    <div className="">
      <div
        onClick={onConnect1}
        style={{ width: "400px" }}
        className="p-6 flex flex-col justify-start margin-top 200px"
      >
        <h5 className="text-gray-900 text-xl font-medium mb-2 ">Connect</h5>
        <p className="text-gray-700 text-base mb-4">Your wallet</p>
      </div>
    </div>
  );
}

export default WalletConnect;
